"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.FooterCopyright = exports.Wrapper = exports.UtilityContainer = exports.FooterSocialWrapper = exports.FooterSocial = exports.FooterUtility = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Layout = require("../../../Layout");

var _mediaQueries = _interopRequireDefault(require("../../../../styles/mediaQueries"));

var _Typography = require("../../../Typography");

var FooterUtility = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      space = _ref$theme.space,
      header = _ref$theme.header,
      footer = _ref$theme.footer;
  return {
    background: colors[header.utilityFooter.background],
    borderTop: footer.footerUtilityStyle,
    borderColor: colors[footer.footerUtilityColor],
    padding: "".concat(space.small, " 0")
  };
});
exports.FooterUtility = FooterUtility;
var FooterSocial = (0, _styled.default)('div')(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      colors = _ref2$theme.colors,
      footer = _ref2$theme.footer;
  return {
    background: colors[footer.footerSocialBg],
    padding: "".concat(space.small, " 0"),
    borderTop: footer.footerSocialBorderStyle,
    borderColor: colors[footer.footerSocialBorderColor],
    color: colors[footer.footerSocialColor],
    svg: {
      fill: colors[footer.footerSocialFill]
    }
  };
});
exports.FooterSocial = FooterSocial;
var FooterSocialWrapper = (0, _styled.default)(_Layout.Container)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      footer = _ref3$theme.footer;
  return _defineProperty({
    display: 'flex',
    justifyContent: 'flex-start',
    color: colors[footer.footerSocialWrapperColor]
  }, _mediaQueries.default.large, {
    justifyContent: 'flex-end'
  });
});
exports.FooterSocialWrapper = FooterSocialWrapper;
var UtilityContainer = (0, _styled.default)(_Layout.Container)(function (_ref5) {
  var _ref6;

  var footer = _ref5.theme.footer;
  return _ref6 = {
    display: 'flex',
    alignItems: footer.utilityContainerFlexAlignMobile,
    justifyContent: 'space-between',
    flexDirection: 'column'
  }, _defineProperty(_ref6, _mediaQueries.default.large, {
    flexDirection: 'row',
    alignItems: footer.utilityContainerFlexAlignDesktop
  }), _defineProperty(_ref6, '& > div', _defineProperty({
    flexDirection: 'column'
  }, _mediaQueries.default.large, {
    flexDirection: 'row'
  })), _defineProperty(_ref6, '& > div a', _defineProperty({
    padding: '8px 0'
  }, _mediaQueries.default.large, {
    padding: 'initial'
  })), _ref6;
});
exports.UtilityContainer = UtilityContainer;
var Wrapper = (0, _styled.default)('footer')(function (_ref7) {
  var _ref7$theme = _ref7.theme,
      space = _ref7$theme.space,
      colors = _ref7$theme.colors,
      footer = _ref7$theme.footer;
  return {
    background: colors[footer.wrapperBg],
    paddingTop: space.small
  };
});
exports.Wrapper = Wrapper;
var FooterCopyright = (0, _styled.default)(_Typography.Body)(function (_ref8) {
  var _ref8$theme = _ref8.theme,
      colors = _ref8$theme.colors,
      footer = _ref8$theme.footer;
  return _defineProperty({
    color: colors[footer.copyrightColor]
  }, _mediaQueries.default.untilLarge, {
    fontSize: footer.copyrightFontSizeMobile
  });
});
exports.FooterCopyright = FooterCopyright;